module.exports = __webpack_public_path__ + "static/media/potmoney.7df94988.png";